import { Controller } from "stimulus";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

export default class extends Controller {
	async produceBankBill(ev) {
		this.produceCharge(ev, 'Vamos gerar um Boleto Bancário através do Gateway de Pagamento configurado. Deseja continuar?', 'Boleto foi gerado com sucesso!');
	}

	async generateQrCode(ev) {
		this.produceCharge(ev, 'Vamos gerar um QR Code através do Gateway de Pagamento configurado. Deseja continuar?', 'QR Code gerado com sucesso!');
	}

	async produceCharge(ev, question, successMessage) {
		let $a = ev.currentTarget,
		result = await sweet_alert.fire({
			icon: '',
			title: 'Atenção',
			text: question,
			showCloseButton: true,
			showCancelButton: true,
			confirmButtonText: 'Sim'
		});

		if (!result.value)
			return;

		AjaxLoader.show();

		try {
			let response = await fetch($a.dataset.href, { method: 'post' })
			response = await response.text();

			try {
				response = JSON.parse(response);
				this.openInNewTab(response.url);

				AjaxLoader.hide();
				await sweet_alert.fire('Pronto', successMessage, 'success');
				window.location.reload();
			} catch(err) {
				sweet_alert.fire({ icon: 'error', text: 'Infelizmente não foi possível abrir o recurso gerado!' });
			}
		} catch(err) {
			sweet_alert.fire({ icon: 'error', text: 'Infelizmente não foi possível concluir a solicitação!' });
		} finally {
			AjaxLoader.hide();
		}
	}

	openInNewTab(href) {
		Object.assign(document.createElement('a'), {
			target: '_blank',
			href: href,
		}).click();
	}
}